<template>
  <div id="app">
    <!-- <nav class="nav">
      <div class="nav-container">
        <router-link to="/" class="nav-brand">Design Team</router-link>
        <div class="nav-links">
          <router-link to="/" class="nav-link">Home</router-link>
          <router-link to="/about" class="nav-link">About</router-link>
          <router-link to="/case-studies" class="nav-link"
            >Case Studies</router-link
          >
          <router-link to="/blog" class="nav-link">Blog</router-link>
          <router-link to="/team" class="nav-link">Team</router-link>
        </div>
      </div>
    </nav> -->
    <main class="main">
      <router-view />
    </main>
  </div>
</template>

<script setup lang="ts">
// Main application component
</script>

<style lang="less"></style>
